export const formatPrice = (price, currency = 'mxn', location = 'es-MX') =>{
    return price.toLocaleString(location, {
        style: 'currency',
        currency: currency,
    })
}